import { render, staticRenderFns } from "./retailers.vue?vue&type=template&id=50c040d8&scoped=true&"
import script from "./retailers.vue?vue&type=script&lang=js&"
export * from "./retailers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c040d8",
  null
  
)

export default component.exports